import React from "react";
import PropTypes from "prop-types";
import { useLocation, useParams } from "react-router-dom";
import { EDIT_PERSONAL_INFO, ACCOUNT } from "../../../constants";
import { Section } from "../../../commons/elements";

const propTypes = {
  user: PropTypes.object.isRequired
};

function PersonalInfo(props) {
  const { user } = props;
  const location = useLocation();
  const params = useParams();

  const editLink = `/${params.shortName}/${ACCOUNT}/${EDIT_PERSONAL_INFO}${location.search}`;

  return (
    <Section title="Personal Info" editLink={editLink}>
      <div className="personal-info-container">
        <div className="mb-2">
          {user.firstName} {user.lastName}
        </div>
        <div className="mb-2">{user.email || user.username}</div>
      </div>
    </Section>
  );
}

PersonalInfo.propTypes = propTypes;

export default PersonalInfo;
